import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

// import { MobileSchedule } from '../model/common.model';


@Pipe({
    name: 'displayCurrency'
})

export class DisplayCurrency implements PipeTransform {

    // integerDivider(numerator: number, divider: number) {
    //     return (numerator - (numerator % divider)) / divider;
    // }
    constructor (private translate: TranslateService) {}

    transform(value: number): any {
        if (value) {
            return this.translate.instant('Currency', {v: (Math.round(value * 100) / 100).toFixed(2)});
        }else {
          return this.translate.instant('Currency', {v: (0).toFixed(2)});
        }
    }
}
